import { handleActions } from 'redux-actions';

import * as actions from '../actions';

const InitialState = null;

export const apiKeyUserReducer = handleActions(
  {
    [actions.setApiKey]: (state, { payload: apiKey }) => apiKey,
  },
  InitialState
);
